import { useApiConfigWebPageResult } from '../../../api/api.configurationWebPageResult';
import { useScreenSize } from '../../../utils/media-query';
import { Button, LoadIndicator, Tooltip, TextBox, Tabs, SelectBox } from 'devextreme-react';
import DataGrid, { Toolbar, Item, SearchPanel, Column, Paging, LoadPanel } from 'devextreme-react/data-grid';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useRef, useState, useEffect, useCallback } from 'react';
import './ConfigUsuarios.scss';
import { groupAdd } from '../../../images/icons';

const Index = () => {
  const { migratePatients, getCenters, getPatients, getListCentersEquival, createUser, restorePassword } = useApiConfigWebPageResult();
  const { isXSmall, isSmall, isMedium } = useScreenSize();
  const gridRef = useRef<DataGrid>(null);
  const [data, setData] = useState<any[]>([]);
  const [showMigrateModal, setShowMigrateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [migratedCount, setMigratedCount] = useState<number | null>(null);
  const [currentTab, setCurrentTab] = useState(0); // Iniciar en pestaña Centros
  const [searchUser, setSearchUser] = useState('');
  const [isLoadingGrid, setIsLoadingGrid] = useState(false);

  // Estados para crear centro
  const [showCreateCenterModal, setShowCreateCenterModal] = useState(false);
  const [availableCenters, setAvailableCenters] = useState<any[]>([]);
  const [selectedCenter, setSelectedCenter] = useState<any>(null);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Estados para restablecer contraseña
  const [showRestorePasswordModal, setShowRestorePasswordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [newPassword, setNewPassword] = useState('');
  const [restoreConfirmPassword, setRestoreConfirmPassword] = useState('');
  const [useDefaultPassword, setUseDefaultPassword] = useState(false);
  const [isRestoringPassword, setIsRestoringPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRestoreConfirmPassword, setShowRestoreConfirmPassword] = useState(false);

  const tabsData = [
    { Value: 0, Text: 'Centros' },
    { Value: 1, Text: 'Pacientes' },
  ];

  useEffect(() => {
    if (currentTab === 0) {
      loadCenters();
    } else if (currentTab === 1) {
      setData([]); // Limpiar datos de pacientes al cambiar de pestaña
    }
  }, [currentTab]);

  const loadCenters = useCallback(async () => {
    setIsLoadingGrid(true);
    try {
      gridRef.current?.instance.beginCustomLoading('');
      const result = await getCenters();

      setData(result);
    } catch (error) {
      console.error('Error loading centers:', error);
    } finally {
      setIsLoadingGrid(false);
      gridRef.current?.instance.endCustomLoading();
    }
  }, [getCenters]);

  const loadPatients = useCallback(async () => {
    if (!searchUser.trim()) {
      return;
    }
    setIsLoadingGrid(true);
    try {
      gridRef.current?.instance.beginCustomLoading('');
      const result = await getPatients(searchUser);
      console.log('Centers loaded:', result);
      setData(result);
    } catch (error) {
      console.error('Error loading patients:', error);
    } finally {
      setIsLoadingGrid(false);
      gridRef.current?.instance.endCustomLoading();
    }
  }, [getPatients, searchUser]);

  const handleSearchPatients = () => {
    if (searchUser.trim()) {
      loadPatients();
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.event.key === 'Enter') {
      handleSearchPatients();
    }
  };

  const handleTabClick = (e: any) => {
    console.log('Cambiando a pestaña:', e.itemData.Value, e.itemData.Text);
    setCurrentTab(e.itemData.Value);
  };

  const handleRenderTitle = (item: any) => {
    return <span className='tab-title'>{item.Text}</span>;
  };

  const handleMigrateClick = () => {
    setShowMigrateModal(true);
    setMigratedCount(null);
  };

  const handleCreateCenterClick = async () => {
    console.log('Abriendo modal de crear centro...');
    setShowCreateCenterModal(true);
    setSelectedCenter(null);
    setPassword('');
    setConfirmPassword('');
    // Cargar centros disponibles
    try {
      console.log('Cargando centros disponibles...');
      const centers = await getListCentersEquival();
      console.log('Centros cargados:', centers);
      setAvailableCenters(centers);
    } catch (error) {
      console.error('Error loading available centers:', error);
    }
  };

  const handleCloseCreateCenterModal = () => {
    setShowCreateCenterModal(false);
    setSelectedCenter(null);
    setPassword('');
    setConfirmPassword('');
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      // Podrías agregar un toast aquí si tienes el sistema de notificaciones
      console.log('Contraseña copiada al portapapeles');
    } catch (err) {
      console.error('Error al copiar al portapapeles:', err);
    }
  };

  const generatePassword = () => {
    const length = 12;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    let generatedPassword = '';
    for (let i = 0; i < length; i++) {
      generatedPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setPassword(generatedPassword);
    setConfirmPassword(generatedPassword);
  };

  const generateNewPassword = () => {
    const length = 12;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    let generatedPassword = '';
    for (let i = 0; i < length; i++) {
      generatedPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setNewPassword(generatedPassword);
    setRestoreConfirmPassword(generatedPassword);
  };

  const handleRestorePasswordClick = (user: any) => {
    setSelectedUser(user);
    setNewPassword('');
    setRestoreConfirmPassword('');
    setUseDefaultPassword(currentTab === 1); // Para pacientes iniciar con contraseña por defecto activada
    setShowRestorePasswordModal(true);
    setShowNewPassword(false);
    setShowRestoreConfirmPassword(false);
  };

  const handleCloseRestorePasswordModal = () => {
    setShowRestorePasswordModal(false);
    setSelectedUser(null);
    setNewPassword('');
    setRestoreConfirmPassword('');
    setUseDefaultPassword(false);
    setShowNewPassword(false);
    setShowRestoreConfirmPassword(false);
  };

  const handleRestorePassword = async () => {
    if (!selectedUser) {
      return;
    }

    // Para pacientes, si está marcado usar contraseña por defecto, enviamos null
    let passwordToSend: string | null = null;
    if (currentTab === 0 || !useDefaultPassword) {
      // Para centros siempre se requiere contraseña, para pacientes solo si no es por defecto
      if (newPassword !== restoreConfirmPassword) {
        return;
      }
      if (!newPassword.trim()) {
        return;
      }
      passwordToSend = newPassword;
    }

    setIsRestoringPassword(true);
    try {
      const success = await restorePassword(selectedUser.Wus_Id, passwordToSend);

      if (success) {
        handleCloseRestorePasswordModal();
        // Recargar datos según la pestaña actual
        if (currentTab === 0) {
          loadCenters();
        } else if (currentTab === 1 && searchUser.trim()) {
          loadPatients();
        }
      }
    } catch (error) {
      console.error('Error restoring password:', error);
    } finally {
      setIsRestoringPassword(false);
    }
  };

  const handleCreateUser = async () => {
    if (!selectedCenter) {
      return;
    }
    if (password !== confirmPassword) {
      return;
    }
    if (!password.trim()) {
      return;
    }

    setIsCreatingUser(true);
    try {
      const success = await createUser(selectedCenter.Id, selectedCenter.Documento, password);
      if (success) {
        handleCloseCreateCenterModal();
        // Recargar centros si estamos en esa pestaña
        if (currentTab === 0) {
          loadCenters();
        }
      }
    } catch (error) {
      console.error('Error creating user:', error);
    } finally {
      setIsCreatingUser(false);
    }
  };

  const handleCloseModal = () => {
    setShowMigrateModal(false);
    setMigratedCount(null);
  };

  const handleConfirmMigration = async () => {
    setIsLoading(true);
    try {
      const result = await migratePatients();
      setMigratedCount(result);
    } catch (error) {
      console.error('Error during migration:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* Debug info - remover en producción */}
      <div style={{ position: 'fixed', top: '10px', right: '10px', backgroundColor: '#333', color: 'white', padding: '5px', borderRadius: '3px', fontSize: '12px', zIndex: 9999 }}>
        Pestaña actual: {currentTab} ({currentTab === 0 ? 'Centros' : 'Pacientes'})
      </div>

      {/* Pestañas */}
      <div style={{ marginBottom: '20px' }}>
        <Tabs dataSource={tabsData} selectedIndex={currentTab} onItemClick={handleTabClick} itemRender={handleRenderTitle} scrollByContent showNavButtons={false} />
      </div>

      {/* Búsqueda de pacientes - Solo visible en pestaña de pacientes */}
      {currentTab === 1 && (
        <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
          <TextBox placeholder='Ingrese usuario para buscar pacientes' value={searchUser} onValueChanged={(e) => setSearchUser(e.value)} onKeyDown={handleKeyPress} width={300} />
          <Button text='Buscar' type='default' onClick={handleSearchPatients} disabled={!searchUser.trim() || isLoadingGrid} />
        </div>
      )}

      {/* DataGrid */}
      <DataGrid
        height={'100%'}
        className='grid'
        ref={gridRef}
        dataSource={data}
        rowAlternationEnabled={true}
        key={currentTab} // Forzar re-render cuando cambie la pestaña
      >
        <LoadPanel enabled={true} />
        <SearchPanel visible placeholder='Buscar' />
        <Paging enabled={false} />

        <Toolbar>
          {/* Botones para centros */}
          {currentTab === 0 && (
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarAddCenter' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Agregar centro
              </Tooltip>
              <Button id='toolBarAddCenter' text={'Agregar'} stylingMode='outlined' icon='plus' type='success' onClick={handleCreateCenterClick} />
            </Item>
          )}

          {currentTab === 0 && (
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarRefreshCenters' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Actualizar
              </Tooltip>
              <Button id='toolBarRefreshCenters' text={'Actualizar'} stylingMode='outlined' icon='refresh' type='default' onClick={loadCenters} disabled={isLoadingGrid} />
            </Item>
          )}

          {/* Botón de migración solo en pestaña de pacientes */}
          {currentTab === 1 && (
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarMigratePatients' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Crear pacientes masivamente para la página web
              </Tooltip>
              <Button id='toolBarMigratePatients' text={'Migrar pacientes'} stylingMode='outlined' icon={groupAdd} type='success' onClick={handleMigrateClick} />
            </Item>
          )}
          <Item name='searchPanel' />
        </Toolbar>

        {/* Columnas dinámicas según la pestaña activa */}
        <Column dataField='Wus_Usuario' caption='USUARIO/DOCUMENTO' width={170} alignment='center' />
        <Column dataField='Wus_IdReferencia' caption='EQUIVALENTE' width={120} alignment='center' />
        <Column dataField={currentTab === 0 ? 'Nombre' : 'Pc_Nombre'} caption='NOMBRE' minWidth={200} />
        <Column dataField='Wus_FechaCreacion' dataType='datetime' format={'dd/MM/yyyy'} caption='CREACION' width={130} alignment='center' />
        <Column
          dataField='Wus_Estado'
          caption='ESTADO'
          width={100}
          alignment='center'
          cellRender={(data) => {
            const isActive = data.value === true || data.value === 'Activo';
            return (
              <span
                style={{
                  backgroundColor: isActive ? '#d4edda' : '#f8d7da',
                  color: isActive ? '#155724' : '#721c24',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: '500',
                }}>
                {isActive ? 'Activo' : 'Inactivo'}
              </span>
            );
          }}
        />
        <Column
          caption='ACCIONES'
          width={120}
          alignment='center'
          allowSorting={false}
          allowFiltering={false}
          cellRender={(data) => (
            <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
              <Tooltip target={`#restorePassword-${data.rowIndex}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Restablecer contraseña
              </Tooltip>
              <Button id={`restorePassword-${data.rowIndex}`} icon='key' stylingMode='text' onClick={() => handleRestorePasswordClick(data.data)} width={24} height={24} />
            </div>
          )}
        />
      </DataGrid>

      <Popup visible={showMigrateModal} onHiding={handleCloseModal} hideOnOutsideClick={false} showCloseButton={true} fullScreen={isXSmall || isSmall || isMedium} width={isXSmall || isSmall || isMedium ? '100%' : 500} height='auto' title='Migrar Pacientes' dragEnabled={false} showTitle={true}>
        <div style={{ padding: '20px' }}>
          {migratedCount === null ? (
            <>
              <p>Esta acción crea todos los pacientes para la página web de resultados que no se hayan creado hasta el momento.</p>
              {isLoading && (
                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                  <LoadIndicator visible={true} />
                  <p style={{ marginTop: '10px' }}>Creando pacientes, esto puede tardar varios minutos...</p>
                </div>
              )}
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <p>¡Migración completada!</p>
              <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#28a745' }}>Se han creado {migratedCount} pacientes</p>
            </div>
          )}
        </div>
        <ToolbarItem toolbar='bottom' location='after'>
          <div className='form-popup-buttons-container'>
            {migratedCount === null ? (
              <>
                <Button text='Cancelar' stylingMode='outlined' onClick={handleCloseModal} disabled={isLoading} />
                <Button text='Confirmar' stylingMode='contained' type='default' onClick={handleConfirmMigration} disabled={isLoading} />
              </>
            ) : (
              <Button text='Aceptar' stylingMode='contained' type='default' onClick={handleCloseModal} />
            )}
          </div>
        </ToolbarItem>
      </Popup>

      {/* Modal para crear centro */}
      <Popup visible={showCreateCenterModal} onHiding={handleCloseCreateCenterModal} hideOnOutsideClick={false} showCloseButton={true} fullScreen={isXSmall || isSmall || isMedium} width={isXSmall || isSmall || isMedium ? '100%' : 600} height='auto' title='Crear Centro' dragEnabled={false} showTitle={true}>
        <div style={{ padding: '20px' }}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Seleccione un centro:</label>
            <SelectBox
              dataSource={availableCenters}
              displayExpr='Nombre'
              valueExpr='Id'
              value={selectedCenter?.Id}
              onValueChanged={(e) => {
                const center = availableCenters.find((c) => c.Id === e.value);
                setSelectedCenter(center);
              }}
              placeholder='Seleccione un centro...'
              searchEnabled={true}
              width='100%'
            />
            {selectedCenter && (
              <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                <strong>Centro seleccionado:</strong>
                <br />
                <strong>ID:</strong> {selectedCenter.Id}
                <br />
                <strong>Documento:</strong> {selectedCenter.Documento}
                <br />
                <strong>Nombre:</strong> {selectedCenter.Nombre}
              </div>
            )}
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Contraseña:</label>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
              <div style={{ position: 'relative', flex: 1 }}>
                <TextBox mode={showPassword ? 'text' : 'password'} value={password} onValueChanged={(e) => setPassword(e.value)} placeholder='Ingrese contraseña' width='100%' />
                <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '4px' }}>
                  <Button icon={showPassword ? 'eyeclose' : 'eyeopen'} stylingMode='text' onClick={() => setShowPassword(!showPassword)} hint={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'} width={24} height={24} />
                  {password && <Button icon='copy' stylingMode='text' onClick={() => copyToClipboard(password)} hint='Copiar contraseña' width={24} height={24} />}
                </div>
              </div>
              <Button text='Generar' icon='key' stylingMode='outlined' onClick={generatePassword} hint='Generar contraseña automáticamente' />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Confirmar contraseña:</label>
            <div style={{ position: 'relative' }}>
              <TextBox mode={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onValueChanged={(e) => setConfirmPassword(e.value)} placeholder='Confirme la contraseña' width='100%' />
              <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '4px' }}>
                <Button icon={showConfirmPassword ? 'eyeclose' : 'eyeopen'} stylingMode='text' onClick={() => setShowConfirmPassword(!showConfirmPassword)} hint={showConfirmPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'} width={24} height={24} />
                {confirmPassword && <Button icon='copy' stylingMode='text' onClick={() => copyToClipboard(confirmPassword)} hint='Copiar contraseña' width={24} height={24} />}
              </div>
            </div>
            {password && confirmPassword && password !== confirmPassword && <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>Las contraseñas no coinciden</div>}
          </div>

          {isCreatingUser && (
            <div style={{ textAlign: 'center', margin: '20px 0' }}>
              <LoadIndicator visible={true} />
              <p style={{ marginTop: '10px' }}>Creando usuario...</p>
            </div>
          )}
        </div>
        <ToolbarItem toolbar='bottom' location='after'>
          <div className='form-popup-buttons-container'>
            <Button text='Cancelar' stylingMode='outlined' onClick={handleCloseCreateCenterModal} disabled={isCreatingUser} />
            <Button text='Crear Usuario' stylingMode='contained' type='default' onClick={handleCreateUser} disabled={!selectedCenter || !password || !confirmPassword || password !== confirmPassword || isCreatingUser} />
          </div>
        </ToolbarItem>
      </Popup>

      {/* Modal para restablecer contraseña */}
      <Popup visible={showRestorePasswordModal} onHiding={handleCloseRestorePasswordModal} hideOnOutsideClick={false} showCloseButton={true} fullScreen={isXSmall || isSmall || isMedium} width={isXSmall || isSmall || isMedium ? '100%' : 500} height='auto' title={`Restablecer Contraseña - ${selectedUser?.Wus_Usuario || ''}`} dragEnabled={false} showTitle={true}>
        <div style={{ padding: '20px' }}>
          <div style={{ marginBottom: '20px' }}>
            <p>
              <strong>Usuario:</strong> {selectedUser?.Wus_Usuario}
            </p>
            <p>
              <strong>Nombre:</strong> {selectedUser?.Nombre || selectedUser?.Pc_Nombre}
            </p>
          </div>

          {/* Opción de contraseña por defecto solo para pacientes */}
          {currentTab === 1 && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input type='checkbox' checked={useDefaultPassword} onChange={(e) => setUseDefaultPassword(e.target.checked)} />
                <span>Generar contraseña por defecto</span>
              </label>
              <small style={{ color: '#666', marginTop: '5px', display: 'block' }}>Al activar esta opción, el sistema generará automáticamente una contraseña por defecto para el paciente.</small>
            </div>
          )}

          {/* Campos de contraseña - Solo mostrar si no es contraseña por defecto para pacientes o si es centro */}
          {(currentTab === 0 || !useDefaultPassword) && (
            <>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nueva contraseña:</label>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                  <div style={{ position: 'relative', flex: 1 }}>
                    <TextBox mode={showNewPassword ? 'text' : 'password'} value={newPassword} onValueChanged={(e) => setNewPassword(e.value)} placeholder='Ingrese nueva contraseña' width='100%' />
                    <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '4px' }}>
                      <Button icon={showNewPassword ? 'eyeclose' : 'eyeopen'} stylingMode='text' onClick={() => setShowNewPassword(!showNewPassword)} hint={showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'} width={24} height={24} />
                      {newPassword && <Button icon='copy' stylingMode='text' onClick={() => copyToClipboard(newPassword)} hint='Copiar contraseña' width={24} height={24} />}
                    </div>
                  </div>
                  <Button text='Generar' icon='key' stylingMode='outlined' onClick={generateNewPassword} hint='Generar contraseña automáticamente' />
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Confirmar contraseña:</label>
                <div style={{ position: 'relative' }}>
                  <TextBox mode={showRestoreConfirmPassword ? 'text' : 'password'} value={restoreConfirmPassword} onValueChanged={(e) => setRestoreConfirmPassword(e.value)} placeholder='Confirme la nueva contraseña' width='100%' />
                  <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '4px' }}>
                    <Button icon={showRestoreConfirmPassword ? 'eyeclose' : 'eyeopen'} stylingMode='text' onClick={() => setShowRestoreConfirmPassword(!showRestoreConfirmPassword)} hint={showRestoreConfirmPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'} width={24} height={24} />
                    {restoreConfirmPassword && <Button icon='copy' stylingMode='text' onClick={() => copyToClipboard(restoreConfirmPassword)} hint='Copiar contraseña' width={24} height={24} />}
                  </div>
                </div>
                {newPassword && restoreConfirmPassword && newPassword !== restoreConfirmPassword && <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>Las contraseñas no coinciden</div>}
              </div>
            </>
          )}

          {isRestoringPassword && (
            <div style={{ textAlign: 'center', margin: '20px 0' }}>
              <LoadIndicator visible={true} />
              <p style={{ marginTop: '10px' }}>Restableciendo contraseña...</p>
            </div>
          )}
        </div>
        <ToolbarItem toolbar='bottom' location='after'>
          <div className='form-popup-buttons-container'>
            <Button text='Cancelar' stylingMode='outlined' onClick={handleCloseRestorePasswordModal} disabled={isRestoringPassword} />
            <Button text='Restablecer Contraseña' stylingMode='contained' type='default' onClick={handleRestorePassword} disabled={isRestoringPassword || (currentTab === 0 && (!newPassword || !restoreConfirmPassword || newPassword !== restoreConfirmPassword)) || (currentTab === 1 && !useDefaultPassword && (!newPassword || !restoreConfirmPassword || newPassword !== restoreConfirmPassword))} />
          </div>
        </ToolbarItem>
      </Popup>
    </div>
  );
};

export default Index;
